<template>
	<div>
		<HeaderMenu></HeaderMenu>
		<div class="course_register_wrap">
			<div class="container">
				<h3>Course Registration</h3>
				<div class="training-course-wrap">
					<h4>SIMULATION EDUCATOR TRAINING COURSE</h4>
					<ul>
						<li>Name:</li>
						<li>SCFHS Registration No.:</li>
						<li>Specialty / Position:</li>
						<li>Place of work:</li>
						<li>Mobile Number:</li>
						<li>E-mail:</li>
					</ul>
					<div class="register_wrap">
						<router-link  v-bind:to="'/register/'">Register now</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import DateRangePicker from 'vue2-daterange-picker'

import HeaderMenu from '../HeaderMenu'
import Pagination from "../Pagination"
	export default {
		data(){
	        this.get_page_content();
	        return {
	            listing:null,
	            hostname:this.$hostname,
	            current_locale:this.$i18n_global.locale,
	            search_input:(this.$route.query.q!="") ? this.$route.query.q : '',
	            dateRange: { 
			        startDate:new Date(),
			        endDate: new Date(),
		      	},
		      	is_search:false,
		      	search_date_value:null
	        }
	    },
	    components:{
	        HeaderMenu:HeaderMenu,
            Pagination:Pagination,
            DateRangePicker:DateRangePicker
	    },
	    methods:{
	    	async get_page_content() {
	            var _self = this; 
	            var page_num = (_self.listing==undefined) ? 1 :  _self.listing.current_page;
	            var query_args={};
	            this.search_input = (this.$route.query.q!="") ? this.$route.query.q : ''
	            if(_self.search_input){
	            	query_args.search_input=_self.search_input;
	            }
	            if(_self.is_search && _self.dateRange && _self.search_date_value){
	            	query_args.dateRange=_self.dateRange;
	            }
	            query_args.page=page_num
	            await this.$axios_global.post(_self.$hostname+'/api/courses',query_args)
	            .then((res) => {
	                var response = res.data.data;
	                _self.listing = response;
	            })
	            .catch((error) => {
	                return false;  
	            }) 
	            return false; 
	        },
	        format_date(value){
		        if (value) {
		           return this.$moment_global(String(value)).format('MMM YYYY')
		        }
		    },
		    updateDates(value){
		    	this.dateRange = value;
		    	this.search_date_value = this.$moment_global(String(value.startDate)).format('YYYY-MM-DD')+ ' - ' + this.$moment_global(String(value.endDate)).format('YYYY-MM-DD')
		    },
		    search(){
		    	this.is_search = true;
		    	this.listing.current_page = 1;
		    	this.$router.push({query: { q: this.search_input }})
		    	this.get_page_content();
		    },
		    reset_search(){
		    	this.is_search = false;
		    	this.listing.current_page = 1;
		    	this.search_input = '';
		    	this.dateRange = { 
			        startDate:new Date(),
			        endDate: new Date(),
		      	}
		      	this.search_date_value = '';
		    	this.$router.push({query: { q: '' }})
		    	this.get_page_content();	
		    }
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/Courses/CoursesListing.vue